export default __webpack_public_path__ + "409bf5f1bcc0583a4011345294c196a8.svg";